/**
 * 결정적 난수 생성기(절차 렌더의 안정적 배치용). 시드가 같으면 항상 같은 수열 →
 * 스크린샷/시각 재현이 안정적이다. 각 호출부의 알고리즘/시드를 바꾸면 배치가 달라지므로,
 * 기존 수열을 보존하려면 여기 함수를 그대로 쓸 것.
 */

/** LCG(Numerical Recipes). screens.ts에서 사용. */
export function lcg(seed: number): () => number {
  let s = seed >>> 0;
  return () => {
    s = (s * 1664525 + 1013904223) >>> 0;
    return s / 4294967296;
  };
}

/** Park–Miller(MINSTD). office.ts의 포스트잇/화분 배치에서 서로 다른 승수로 사용. */
export function parkMiller(seed: number, mult: number): () => number {
  let s = seed;
  return () => {
    s = (s * mult) % 2147483647;
    return s / 2147483647;
  };
}

/** mulberry32(고품질 32비트 스트림). officeTextures.ts·DeskCracks.ts의 절차 텍스처 재현성용. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
